/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// B端 - 判断用户是否能看到该页面
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=148319311
export const is_bd_user = createAsyncThunk(
  '/live/room/get_b_status',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        status: number
      }>
    >('/live/room/get_b_status', {}, {store})
    // return {
    //   status: 1,
    // }
    return resp.data.data
  }
)

const initialState = {
  is_white: true, // -1 拦截
}
export const UserIdentityVerifySlice = createSlice({
  name: 'UserIdentityVerify',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 不是-1才是白名单
    builder.addCase(is_bd_user.fulfilled, (state, action) => {
      Object.assign(state, {
        is_white: action.payload.status !== -1,
      })
    })
    // 接口出错拦截
    builder.addCase(is_bd_user.rejected, (state, action) => {
      Object.assign(state, {
        is_white: false,
      })
    })
  },
})
export default UserIdentityVerifySlice.reducer
export const UserIdentityVerifyActions = UserIdentityVerifySlice.actions
